export const BuildInfo = {timestamp:1790279372000}
